/* NBT: vertaalt een tekst via window.NB_T. Zonder tabel (Japans) komt het origineel terug.
   Staat de hele tekst er niet in, dan worden bekende woorden binnenin vervangen (HTML-fragmenten). */
function NBT(s) {
  var T = window.NB_T;
  if (!T || typeof s !== 'string') return s;
  if (Object.prototype.hasOwnProperty.call(T, s)) return T[s];
  var k = window.NB_TK || (window.NB_TK = Object.keys(T).sort(function (a, b) { return b.length - a.length; }));
  var uit = s;
  for (var i = 0; i < k.length; i++) {
    if (uit.indexOf(k[i]) !== -1) uit = uit.split(k[i]).join(T[k[i]]);
  }
  return uit;
}
/* NOBIASHI productpagina: galerij, kleur/maat, サイズ表, maat-quiz, bundel, winkelwagen, verzenddatum. Opbouw van hike-footwear.com. */
(function () {
  'use strict';

  var root = document.querySelector('[data-nb-product-root]');
  if (!root) return;
  var P = JSON.parse(root.querySelector('[data-nb-product]').textContent);

  /* ---------------------------------------------------------------- helpers */
  function q(sel, el) { return (el || document).querySelector(sel); }
  function qa(sel, el) { return Array.prototype.slice.call((el || document).querySelectorAll(sel)); }
  // サイズ表-lade en quiz buiten de pagina-stacking-context zetten, anders schuift de sticky header eroverheen
  ['[data-nb-maattabel]', '[data-nb-quiz]', '[data-nb-sticky]'].forEach(function (sel) {
    var el = root.querySelector(sel);
    if (!el) return;
    var wrap = document.createElement('div'); wrap.className = 'nb';
    wrap.style.position = 'relative'; wrap.style.zIndex = sel === '[data-nb-sticky]' ? '45' : '9000';  // lade/quiz boven de header (z-50), sticky balk eronder
    wrap.appendChild(el); document.body.appendChild(wrap);
  });
  function yen(n) {
    var s = Math.round(n / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (P.geld || '¥{{amount_no_decimals}}').replace(/\{\{.*?\}\}/, s).replace(/<[^>]+>/g, '');
  }
  function cm(label) { var m = String(label).match(/(\d+(?:\.\d)?)/); return m ? parseFloat(m[1]) : NaN; }
  function toon(el, aan) { if (el) el.classList.toggle('tw-hidden', !aan); }

  var chart = P.maattabel && P.maattabel.rijen ? P.maattabel.rijen : null; // [label, W, M, EU, cm, breedte]
  function rij(label) {
    if (!chart) return null;
    var c = cm(label);
    for (var i = 0; i < chart.length; i++) if (cm(chart[i][0]) === c) return chart[i];
    return null;
  }

  /* ---------------------------------------------------------------- staat */
  var gender = P.alleen || 'women'; // alleen = 'men' bij modellen met alleen herenmaten
  var kleur = P.kleurIdx >= 0 ? (P.varianten[0] || {}).kleur : '';
  function eersteOpVoorraad(k) { // eerste variant van kleur k die op voorraad is, anders de eerste van die kleur
    var eerste = null;
    for (var i = 0; i < P.varianten.length; i++) {
      var v = P.varianten[i]; if (P.kleurIdx >= 0 && v.kleur !== k) continue;
      if (v.beschikbaar) return v; if (!eerste) eerste = v;
    }
    return eerste;
  }
  var maat = P.maatIdx >= 0 ? (eersteOpVoorraad(kleur) || P.varianten[0] || {}).maat : '';
  var bundelQty = 1;
  var paren = [];

  function variant(k, m) {
    for (var i = 0; i < P.varianten.length; i++) {
      var v = P.varianten[i];
      if ((P.kleurIdx < 0 || v.kleur === k) && (P.maatIdx < 0 || v.maat === m)) return v;
    }
    return null;
  }
  function beschikbaar(k, m) { var v = variant(k, m); return !!(v && v.beschikbaar); }
  // Bestaat de combinatie kleur+maat niet, dan is er geen variant: niet terugvallen op varianten[0],
  // anders belandt een andere maat (23.0cm) in de winkelwagen als je een niet-bestaande maat kiest.
  function huidig() { return variant(kleur, maat); }
  function toonVariant() { // alleen voor prijs/foto: eerste variant van de gekozen kleur
    var v = huidig(); if (v) return v;
    for (var i = 0; i < P.varianten.length; i++) { if (P.kleurIdx < 0 || P.varianten[i].kleur === kleur) return P.varianten[i]; }
    return P.varianten[0];
  }

  /* ---------------------------------------------------------------- galerij */
  var track = q('[data-nb-gal-track]');
  var dots = q('[data-nb-gal-dots]');
  var main = q('[data-nb-gal-main]');
  var thumbs = qa('[data-nb-gal-thumb]');
  var galIdx = 0;
  function galNaar(i) {
    if (!P.media.length) return;
    i = (i + P.media.length) % P.media.length;
    galIdx = i;
    if (main && P.media[i]) { main.src = P.media[i].src; main.srcset = ''; main.alt = P.media[i].alt || ''; }
    thumbs.forEach(function (t, j) {
      t.classList.toggle('is-actief', j === i);
      var actief = j === i;
      t.classList.toggle('ring-1', actief); t.classList.toggle('ring-[#538125]', actief); t.classList.toggle('border-[#538125]', actief);
      t.classList.toggle('border-gray-light', !actief); t.classList.toggle('opacity-70', !actief);
      if (actief && t.parentElement) t.parentElement.scrollTo({ left: t.offsetLeft - t.parentElement.offsetLeft - t.parentElement.clientWidth / 2 + t.clientWidth / 2, behavior: 'smooth' });
    });
    zetTeller(i);
    if (track && track.children[i] && window.innerWidth < 768) track.scrollTo({ left: track.children[i].offsetLeft - track.offsetLeft, behavior: 'smooth' });
  }
  function zetTeller(i) {
    qa('[data-nb-gal-teller], [data-nb-gal-teller-mob]').forEach(function (t) { t.textContent = (i + 1) + ' / ' + P.media.length; });
    if (dots) Array.prototype.forEach.call(dots.children, function (d, j) { d.classList.toggle('is-actief', j === i); });
  }
  var prev = q('[data-nb-gal-prev]'), next = q('[data-nb-gal-next]');
  if (prev) prev.addEventListener('click', function () { galNaar(galIdx - 1); });
  if (next) next.addEventListener('click', function () { galNaar(galIdx + 1); });
  function galDots() {
    if (!dots || !track) return;
    dots.innerHTML = '';
    if (track.children.length < 2) return;
    dots.classList.toggle('is-veel', track.children.length > 14);
    for (var i = 0; i < track.children.length; i++) {
      var d = document.createElement('span');
      if (i === 0) d.className = 'is-actief';
      dots.appendChild(d);
    }
  }
  galDots();
  zetTeller(0);
  if (track) track.addEventListener('scroll', function () {
    var i = Math.round(track.scrollLeft / track.clientWidth);
    if (i === galIdx) return;
    galIdx = i;
    zetTeller(i);
  }, { passive: true });
  thumbs.forEach(function (t) { t.addEventListener('click', function () { galNaar(parseInt(t.getAttribute('data-nb-gal-thumb'), 10)); }); });

  /* ---------------------------------------------------------------- kleur + maat */
  var kleurenWrap = q('[data-nb-kleuren]');
  var matenWrap = q('[data-nb-maten]');
  function usTekst(label) {
    return ''; // maten alleen in cm (21-09-2026)
  }
  function kleurCss(naam) {
    var map = { "ブラック": '#1f1f1f', "ホワイト": '#f7f7f5', "グレー": '#9ca3af', "ベージュ": '#d9c6a5', "ブラウン": '#7a5230', "キャメル": '#b9853f', "キャラメル": '#b5773a',
      "ネイビー": '#1e2a4a', "ブルー": '#3b82f6', "ライトブルー": '#a5c8e8', "グリーン": '#4d7137', "オリーブ": '#6b7045', "カーキ": '#7c7a4f', "イエロー": '#e3b52d',
      "オレンジ": '#e8762c', "レッド": '#c8342b', "ローズレッド": '#c2385a', "ピンク": '#f2a7b8', "パープル": '#7e5aa6' };
    if (map[naam]) return map[naam];
    var delen = naam.split('×');
    if (delen.length === 2 && map[delen[0]] && map[delen[1]]) return 'linear-gradient(135deg,' + map[delen[0]] + ' 50%,' + map[delen[1]] + ' 50%)';
    return '#e5e7eb';
  }
  function renderKleuren() {
    if (!kleurenWrap) return;
    kleurenWrap.innerHTML = '';
    P.kleuren.forEach(function (k) {
      var b = document.createElement('button');
      b.type = 'button';
      var actief = k.naam === kleur;
      b.className = 'tw-relative shrink-0 w-16 h-16 rounded-lg overflow-hidden tw-flex items-center tw-justify-center transition-all duration-200 tw-border border-solid cursor-pointer ' + (actief ? 'border-[#538125] ring-1 ring-[#538125]' : 'border-gray-light hover:border-[#538125]');
      b.setAttribute('aria-label', k.naam);
      b.setAttribute('aria-pressed', actief ? 'true' : 'false');
      if (k.img) {
        b.innerHTML = '<div class="w-full h-full tw-relative rounded-[6px] lg:rounded-[7px] overflow-hidden"><img class="object-cover w-full h-full" alt="' + k.naam + '" loading="lazy"></div>';
        b.querySelector('img').src = k.img;
      } else {
        // geen variantfoto: kleurbolletje + naam in plaats van een kapot plaatje
        b.innerHTML = '<span style="display:flex;flex-direction:column;align-items:center;gap:4px"><span style="width:26px;height:26px;border-radius:50%;border:1px solid #d1d5db;background:' + kleurCss(k.naam) + '"></span><span style="font-size:10px;line-height:1.1;color:#374151">' + k.naam + '</span></span>';
      }
      b.addEventListener('click', function () { kleur = k.naam; naKeuze(true); });
      kleurenWrap.appendChild(b);
    });
    var wrap = q('[data-nb-kleuren-wrap]');
    if (wrap) wrap.classList.toggle('is-scroll', kleurenWrap.scrollWidth > kleurenWrap.clientWidth + 2);
    var act = kleurenWrap.querySelector('[aria-pressed="true"]');
    if (act && window.innerWidth < 1024) {
      var links = act.offsetLeft - kleurenWrap.offsetLeft;
      if (links < kleurenWrap.scrollLeft || links + act.offsetWidth > kleurenWrap.scrollLeft + kleurenWrap.clientWidth) kleurenWrap.scrollLeft = Math.max(0, links - 8);
    }
  }
  function renderMaten() {
    if (!matenWrap) return;
    matenWrap.innerHTML = '';
    P.maten.forEach(function (m) {
      var b = document.createElement('button');
      b.type = 'button';
      var actief = m === maat, ok = beschikbaar(kleur, m);
      b.className = 'px-3 py-1.5 min-w-[3rem] rounded-md tw-border text-sm font-medium transition-all duration-200 cursor-pointer ' + (actief ? 'border-green bg-green-light text-green' : ok ? 'border-gray bg-white text-black hover:border-gray-dark' : 'border-gray bg-white text-black/40 line-through');
      b.setAttribute('aria-pressed', actief ? 'true' : 'false');
      b.textContent = m;
      // uitverkocht (of bestaat niet voor deze kleur): niet te kiezen
      if (!ok) { b.disabled = true; b.setAttribute('aria-disabled', 'true'); b.style.cursor = 'not-allowed'; }
      else b.addEventListener('click', function () { maat = m; naKeuze(false); });
      matenWrap.appendChild(b);
    });
  }
  function naKeuze(kleurGewijzigd) {
    // Heeft de nieuwe kleur de gekozen maat niet, schuif dan naar de eerste maat die hij wel heeft.
    // Anders viel huidig() terug op varianten[0] — een variant van een ANDERE kleur (prijs, foto, winkelwagen).
    if (kleurGewijzigd && P.kleurIdx >= 0 && P.maatIdx >= 0 && !beschikbaar(kleur, maat)) {
      var eersteVanKleur = eersteOpVoorraad(kleur);
      if (eersteVanKleur) maat = eersteVanKleur.maat;
    }
    var v = toonVariant();
    renderKleuren(); renderMaten();
    var kn = q('[data-nb-kleur-naam]'); if (kn) kn.textContent = kleur;
    var mn = q('[data-nb-maat-naam]'); if (mn) mn.textContent = maat;
    var sk = q('[data-nb-sticky-kleur]'); if (sk) sk.textContent = kleur;
    var sm = q('[data-nb-sticky-maat]'); if (sm) sm.textContent = maat;
    var mu = q('[data-nb-maat-us]'); if (mu) mu.textContent = usTekst(maat);
    qa('[data-nb-prijs]').forEach(function (e) { e.textContent = yen(v.prijs); });
    qa('[data-nb-vanprijs]').forEach(function (e) { e.textContent = yen(v.van); toon(e, v.van > v.prijs); });
    if (kleurGewijzigd) {
      var kb = null;
      for (var ki = 0; ki < P.kleuren.length; ki++) { if (P.kleuren[ki].naam === kleur) { kb = P.kleuren[ki]; break; } }
      var bron = (v && v.kleur === kleur && v.img) || (kb && (kb.imgGroot || kb.img)) || '';
      if (bron) {
        var i = -1;
        P.media.forEach(function (m, j) { if (i < 0 && m.src.split('?')[0] === bron.split('?')[0]) i = j; });
        if (i >= 0) galNaar(i);
        qa('[data-nb-bundel-img]').forEach(function (img) { img.src = bron; });
      }
    }
    renderBundel();
  }

  /* ---------------------------------------------------------------- geslacht-tabs */
  function zetGender(g) {
    gender = g;
    var slider = q('[data-nb-gender-slider]');
    if (slider) slider.style.transform = gender === 'men' ? 'translateX(100%)' : 'translateX(0)';
    qa('[data-nb-gender-btn]').forEach(function (x) { x.style.color = x.getAttribute('data-nb-gender-btn') === gender ? '#538125' : '#4A5565'; });
    var mu = q('[data-nb-maat-us]'); if (mu) mu.textContent = usTekst(maat);
    // maattabel heeft een vaste kop; geen geslachtsafhankelijke US-rijen meer
    // maattabel: alleen de US-rij van het gekozen geslacht tonen (als er twee zijn)
    var rijen = qa('[data-nb-chart-rij]');
    rijen.forEach(function (r) { r.style.display = rijen.length > 1 && r.getAttribute('data-nb-chart-rij') !== gender ? 'none' : ''; });
  }
  qa('[data-nb-gender-btn]').forEach(function (b) {
    b.addEventListener('click', function () { zetGender(b.getAttribute('data-nb-gender-btn')); });
  });
  if (q('[data-nb-gender]') || P.alleen) zetGender(gender);

  /* ---------------------------------------------------------------- サイズ表-lade */
  var lade = q('[data-nb-maattabel]');
  qa('[data-nb-open-maattabel]').forEach(function (b) { b.addEventListener('click', function () { toon(lade, true); document.documentElement.style.overflow = 'hidden'; }); });
  qa('[data-nb-maattabel-sluit]').forEach(function (b) { b.addEventListener('click', function () { toon(lade, false); document.documentElement.style.overflow = ''; }); });

  /* ---------------------------------------------------------------- bundel */
  var KORTING = { 1: 0, 2: 0.10, 3: 0.20 };
  // Shopify rondt de kortingsprijs af op hele ¥100 (¥10,999 → ¥9,900 bij 2 paar); reken hier net zo,
  // anders staat op de pagina ¥9,899 en in de kassa ¥9,900. Prijzen zijn in sen, dus ¥100 = 10000.
  function paarPrijs(qty) { var k = KORTING[qty] || 0; return k ? Math.ceil(P.prijs * (1 - k) / 10000) * 10000 : P.prijs; }
  function renderBundel() {
    if (!P.bundel) { renderAtc(); return; }
    qa('[data-nb-bundel-prijs]').forEach(function (e) { e.textContent = yen(paarPrijs(parseInt(e.getAttribute('data-nb-bundel-prijs'), 10))); });
    qa('[data-nb-bundel-van]').forEach(function (e) { e.textContent = yen(P.vanPrijs); });
    qa('[data-nb-bundel-keuze]').forEach(function (b) {
      var aan = parseInt(b.getAttribute('data-nb-bundel-keuze'), 10) === bundelQty;
      b.classList.toggle('border-[#538125]', aan); b.classList.toggle('ring-1', aan); b.classList.toggle('ring-[#538125]', aan);
      b.classList.toggle('border-[#D1D5DC]', !aan);
    });
    var wrap = q('[data-nb-paren-wrap]');
    toon(wrap, bundelQty > 1);
    if (bundelQty > 1) renderParen();
    renderAtc();
  }
  function renderParen() {
    var host = q('[data-nb-paren]');
    host.innerHTML = '';
    while (paren.length < bundelQty) paren.push({ kleur: kleur, maat: maat });
    paren.length = bundelQty;
    paren.forEach(function (p, i) {
      var v = variant(p.kleur, p.maat);
      var el = document.createElement('div');
      el.className = 'tw-border border-[#E5E7EB] rounded-[14px] p-3';
      var opties = '';
      if (P.kleurIdx >= 0) opties += NBT("<label class=\"tw-flex flex-col gap-1 text-xs text-gray-500\" style=\"min-width:0\">カラー<span class=\"tw-relative\"><select data-nb-paar-kleur=\"") + i + '" class="w-full appearance-none bg-white tw-border border-gray rounded-xl px-3 py-2.5 pr-7 text-sm text-gray-800 focus:outline-none focus:border-[#6B8F4E] cursor-pointer">' + P.kleuren.map(function (k) { return '<option value="' + k.naam + '"' + (k.naam === p.kleur ? ' selected' : '') + '>' + k.naam + '</option>'; }).join('') + '</select><span class="pointer-events-none absolute inset-y-0 right-2.5 tw-flex items-center text-gray-400">▾</span></span></label>';
      if (P.maatIdx >= 0) opties += NBT("<label class=\"tw-flex flex-col gap-1 text-xs text-gray-500\" style=\"min-width:0\">サイズ<span class=\"tw-relative\"><select data-nb-paar-maat=\"") + i + '" class="w-full appearance-none bg-white tw-border border-gray rounded-xl px-3 py-2.5 pr-7 text-sm text-gray-800 focus:outline-none focus:border-[#6B8F4E] cursor-pointer">' + P.maten.map(function (m) { return '<option value="' + m + '"' + (m === p.maat ? ' selected' : '') + (beschikbaar(p.kleur, m) ? '' : ' disabled') + '>' + m + (beschikbaar(p.kleur, m) ? '' : NBT("（売り切れ）")) + '</option>'; }).join('') + '</select><span class="pointer-events-none absolute inset-y-0 right-2.5 tw-flex items-center text-gray-400">▾</span></span></label>';
      el.innerHTML = '<div class="tw-flex items-center justify-between mb-2"><div class="tw-flex items-center gap-2"><span class="font-bold text-sm">' + (i + 1) + NBT("足目</span><span class=\"text-[11px] font-semibold px-2 py-0.5 rounded-full ") + (v && v.beschikbaar ? 'bg-[#E3ECD5] text-[#25400F]' : 'bg-red-100 text-red') + '">' + (v && v.beschikbaar ? "在庫あり" : NBT("売り切れ")) + '</span></div>' + (bundelQty > 1 ? NBT("<button type=\"button\" class=\"text-gray-400 hover:text-black\" aria-label=\"削除\" data-nb-paar-weg=\"") + i + '">✕</button>' : '') + '</div>' +
        '<div style="display:grid;grid-template-columns:48px repeat(' + ((P.kleurIdx >= 0) + (P.maatIdx >= 0)) + ',minmax(0,1fr));gap:8px;align-items:end"><div class="tw-border border-gray rounded-xl overflow-hidden bg-white" style="width:48px;height:48px"><img class="object-contain w-full h-full" alt="" src="' + ((v && v.img) || P.kleuren.length && P.kleuren[0].img || '') + '"></div>' + opties + '</div>';
      host.appendChild(el);
    });
    if (bundelQty < 3) {
      var meer = document.createElement('button');
      meer.type = 'button';
      meer.className = 'w-full border-2 border-dashed border-[#538125] rounded-[14px] py-3 px-4 tw-flex flex-col items-center tw-justify-center transition-all bg-white hover:bg-[#538125]/20 active:scale-[0.99]';
      meer.innerHTML = NBT("<div class=\"text-base font-semibold text-[#538125] tw-flex items-center gap-1.5 font-poppins tw-text-center\"><span class=\"text-2xl\">+</span> もう1足追加する</div><p class=\"text-xs font-medium text-[#25400FE5] leading-[127%] tracking-[-0.14px] font-poppins tw-text-center\">ご注文全体で") + Math.round(KORTING[bundelQty + 1] * 100) + NBT("%オフ</p>");
      meer.addEventListener('click', function () { bundelQty += 1; renderBundel(); });
      host.appendChild(meer);
    }
    qa('[data-nb-paar-kleur]').forEach(function (s) { s.addEventListener('change', function () { paren[parseInt(s.getAttribute('data-nb-paar-kleur'), 10)].kleur = s.value; renderParen(); renderAtc(); }); });
    qa('[data-nb-paar-maat]').forEach(function (s) { s.addEventListener('change', function () { paren[parseInt(s.getAttribute('data-nb-paar-maat'), 10)].maat = s.value; renderParen(); renderAtc(); }); });
    qa('[data-nb-paar-weg]').forEach(function (b) { b.addEventListener('click', function () { paren.splice(parseInt(b.getAttribute('data-nb-paar-weg'), 10), 1); bundelQty -= 1; if (bundelQty < 1) bundelQty = 1; renderBundel(); }); });
  }
  qa('[data-nb-bundel-keuze]').forEach(function (b) {
    b.addEventListener('click', function () {
      var n = parseInt(b.getAttribute('data-nb-bundel-keuze'), 10);
      bundelQty = bundelQty === n ? 1 : n;
      renderBundel();
    });
  });

  /* ---------------------------------------------------------------- winkelwagen */
  function aantal() { var el = q('[data-nb-qty]'); var n = el ? parseInt(el.value, 10) : 1; return isNaN(n) || n < 1 ? 1 : Math.min(n, 10); }
  function regels() {
    if (bundelQty > 1) return paren.map(function (p) { return variant(p.kleur, p.maat); });
    var r = [], v = huidig(); for (var i = 0; i < aantal(); i++) r.push(v);
    return r;
  }
  (function () {
    var el = q('[data-nb-qty]'); if (!el) return;
    var zet = function (n) { el.value = Math.max(1, Math.min(10, n)); renderAtc(); };
    var mn = q('[data-nb-qty-min]'), pl = q('[data-nb-qty-plus]');
    if (mn) mn.addEventListener('click', function () { zet(aantal() - 1); });
    if (pl) pl.addEventListener('click', function () { zet(aantal() + 1); });
    el.addEventListener('change', function () { zet(aantal()); });
  })();
  function renderAtc() {
    var items = regels();
    var ok = items.every(function (v) { return v && v.beschikbaar; });
    var btn = q('[data-nb-atc]');
    if (!btn) return;
    btn.disabled = !ok;
    var lab = q('[data-nb-atc-label]'); if (lab) lab.textContent = ok ? NBT("カートに追加する") : NBT("売り切れ");
    var sb = q('[data-nb-sticky-atc]'); if (sb) { sb.disabled = !ok; sb.textContent = ok ? NBT("カートに追加する") : NBT("売り切れ"); }
    var n = items.length;
    var van = q('[data-nb-atc-van]'), pr = q('[data-nb-atc-prijs]');
    if (van) van.textContent = yen(P.vanPrijs * n);
    if (pr) pr.textContent = yen(paarPrijs(n) * n);
  }
  function voegToe() {
    var items = regels();
    var telling = {};
    items.forEach(function (v) { if (v) telling[v.id] = (telling[v.id] || 0) + 1; });
    var body = { items: Object.keys(telling).map(function (id) { return { id: parseInt(id, 10), quantity: telling[id] }; }), sections: 'nb-cart-drawer' };
    var btn = q('[data-nb-atc]'), fout = q('[data-nb-atc-fout]');
    btn.disabled = true;
    toon(fout, false);
    fetch(P.cartAdd + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        btn.disabled = false;
        if (res.status) { fout.textContent = res.description || res.message || NBT("カートに追加できませんでした"); toon(fout, true); return; }
        if (res.sections && res.sections['cart-drawer-section']) {
          var sec = document.getElementById('shopify-section-cart-drawer-section');
          if (sec) { var tmp = document.createElement('div'); tmp.innerHTML = res.sections['cart-drawer-section']; var nieuw = tmp.firstElementChild; if (nieuw) sec.replaceWith(nieuw); }
        }
        if (window.NBCart && res.sections && res.sections['nb-cart-drawer']) window.NBCart.zetInhoud(res.sections['nb-cart-drawer']);
        document.dispatchEvent(new CustomEvent('cart:update'));
        var drawer = window.NBCart || document.getElementById('cart-drawer');
        if (drawer && typeof drawer.open === 'function') drawer.open(); else window.location.href = P.root + 'cart';
      })
      .catch(function () { btn.disabled = false; fout.textContent = NBT("通信エラーが発生しました。もう一度お試しください。"); toon(fout, true); });
  }
  var atcBtn = q('[data-nb-atc]');
  if (atcBtn) atcBtn.addEventListener('click', voegToe);

  /* ---------------------------------------------------------------- sticky winkelwagenbalk (Hike) */
  (function () {
    var bar = q('[data-nb-sticky]');
    if (!bar || !atcBtn || !('IntersectionObserver' in window)) return;
    var header = document.getElementById('main-header-wrapper');
    var knop = q('[data-nb-sticky-atc]');
    if (knop) knop.addEventListener('click', function () { if (!atcBtn.disabled) atcBtn.click(); });
    function zet(zichtbaar) {
      // direct onder de header als die (nog) in beeld is, anders tegen de bovenrand
      var hb = header ? header.getBoundingClientRect().bottom : 0;
      bar.style.top = Math.max(0, Math.min(hb, 120)) + 'px';
      bar.classList.toggle('is-zichtbaar', zichtbaar);
      bar.setAttribute('aria-hidden', zichtbaar ? 'false' : 'true');
    }
    new IntersectionObserver(function (es) {
      var e = es[0];
      zet(!e.isIntersecting && e.boundingClientRect.top < 0);
    }, { threshold: 0 }).observe(atcBtn);
  })();

  /* ---------------------------------------------------------------- verzenddatum (JST, 1 werkdag verwerking) */
  (function () {
    var el = q('[data-nb-verzenddatum]');
    if (!el) return;
    var jst = new Date(Date.now() + 9 * 3600 * 1000);
    var d = new Date(Date.UTC(jst.getUTCFullYear(), jst.getUTCMonth(), jst.getUTCDate()));
    var stappen = 1;
    while (stappen > 0) { d.setUTCDate(d.getUTCDate() + 1); if (d.getUTCDay() !== 0 && d.getUTCDay() !== 6) stappen--; }
    var dagen = [NBT("日"), NBT("月"), NBT("火"), NBT("水"), NBT("木"), NBT("金"), NBT("土")];
    el.textContent = (d.getUTCMonth() + 1) + NBT("月") + d.getUTCDate() + NBT("日（") + dagen[d.getUTCDay()] + '）';
  })();

  /* ---------------------------------------------------------------- maat-quiz */
  var QUIZ = window.NB_QUIZ_REGELS || {};
  var MERKEN_TOP = [NBT("ナイキ"), NBT("アディダス")];
  // merklogo's boven de twee populaire merken (Noah, 22-09-2026); Nike = swoosh, adidas = drie strepen + woordmerk
  var MERK_LOGO = { "ナイキ": "<img src=\"https://cdn.shopify.com/s/files/1/1084/8901/5627/files/nb-logo-nike3.png\" alt=\"Nike\" style=\"height:30px;width:auto;display:block\">", "アディダス": "<img src=\"https://cdn.shopify.com/s/files/1/1084/8901/5627/files/nb-logo-adidas3.png\" alt=\"adidas\" style=\"height:44px;width:auto;display:block\">" };
  var MERKEN = [NBT("ニューバランス"), NBT("アシックス"), NBT("スケッチャーズ"), NBT("バンズ"), NBT("コンバース"), NBT("プーマ"), NBT("ミズノ"), NBT("リーボック")];
  // hoe het merk valt t.o.v. de cm-maat op het label (+ = valt groot, - = valt klein) -> correctie in cm
  // Hoe het merk valt t.o.v. de cm op het label. Nike/Puma vallen klein en smal (mensen kopen 0,5cm groter), Converse valt groot,
  // Adidas/New Balance/Asics/Mizuno/Skechers/Vans/Reebok zijn true-to-size. Waarde = wat je bij NOBIASHI (true-to-size) moet corrigeren.
  var MERK_OFFSET = QUIZ.merk || { "ナイキ": 0.5, "アディダス": 0, "ニューバランス": 0, "アシックス": 0, "スケッチャーズ": 0, "バンズ": 0, "コンバース": -0.5, "プーマ": 0.5, "ミズノ": 0, "リーボック": 0 };
  var quiz = q('[data-nb-quiz]');
  var stap = 1, antw = {};
  var STAPPEN = [
    { titel: NBT("普段どのブランドの靴を履いていますか？"), sub: NBT("今の履き心地に合わせておすすめします"), sec: 60 },
    { titel: NBT("{merk}でのサイズは？"), sub: NBT("いちばんよく履くサイズを選んでください"), sec: 50 },
    { titel: NBT("{merk}の靴の履き心地は？"), sub: NBT("一日履いたあとの感覚を思い出してください"), sec: 40 },
    { titel: NBT("あなたの足の幅は？"), sub: NBT("足の形にいちばん近いものを選んでください"), sec: 30 },
    { titel: NBT("つま先のゆとりはどのくらいがお好みですか？"), sub: NBT("ゆとりがあるほど、足が自然に動きます"), sec: 20 },
    { titel: NBT("気になることはありますか？"), sub: NBT("当てはまるものをすべて選んでください（複数可）"), sec: 10 },
    { titel: NBT("主にどこで履きますか？"), sub: NBT("最後の質問です！快適さの決め手になります"), sec: 10 }
  ];
  function opener() { toon(quiz, true); document.documentElement.style.overflow = 'hidden'; stap = 1; antw = { gender: gender }; renderStap(); }
  function sluit() { toon(quiz, false); document.documentElement.style.overflow = ''; }
  qa('[data-nb-open-quiz]').forEach(function (b) { b.addEventListener('click', opener); });
  qa('[data-nb-quiz-sluit]').forEach(function (b) { b.addEventListener('click', sluit); });
  var terug = q('[data-nb-quiz-terug]');
  if (terug) terug.addEventListener('click', function () { if (stap > 1) { stap--; renderStap(); } });

  function knop(html, cls) { var b = document.createElement('button'); b.type = 'button'; b.className = cls; b.innerHTML = html; return b; }
  function optieKaart(label, sub, icoon, cls) {
    var b = knop('<span class="block font-semibold text-black text-base leading-snug">' + label + '</span>' + (sub ? '<span class="block text-sm text-black/60 mt-1 leading-snug">' + sub + '</span>' : ''),
      'w-full tw-border border-[#E5E7EB] rounded-2xl px-5 py-4 hover:border-[#538125] hover:bg-[#F8FAF8] transition-all cursor-pointer tw-text-left ' + (cls || ''));
    b.style.alignSelf = 'stretch'; b.style.minHeight = '84px';
    return b;
  }
  function volgendeKnop(tekst) { return knop(tekst, 'w-full bg-[#538125] text-white rounded-[10px] py-4 font-bold text-lg mt-3 hover:bg-[#4d7a22] disabled:opacity-40'); }
  function renderStap() {
    var body = q('[data-nb-quiz-body]');
    var sec = q('[data-nb-quiz-sec]');
    var lijst = q('[data-nb-quiz-stappen]');
    toon(terug, stap > 1 && stap <= 7);
    var st = Math.min(stap, 7);
    var nr = q('[data-nb-quiz-nr]'); if (nr) nr.textContent = st;
    var pct = q('[data-nb-quiz-pct]'); if (pct) pct.textContent = Math.round(st / 7 * 100) + '%';
    var balk = q('[data-nb-quiz-balk]'); if (balk) balk.style.width = Math.round(st / 7 * 100) + '%';
    lijst.innerHTML = '';
    for (var i = 1; i <= 7; i++) {
      var li = document.createElement('li');
      var klaar = i < st, nu = i === st;
      li.innerHTML = '<span class="w-7 h-7 rounded-full tw-flex items-center tw-justify-center text-xs font-bold" style="' + (klaar ? 'background:#fff;color:#538125' : nu ? 'background:#fff;color:#538125;box-shadow:0 0 0 3px rgba(255,255,255,.45)' : 'background:transparent;color:#fff;border:2px solid rgba(255,255,255,.6)') + '">' + (klaar ? '<svg viewBox="0 0 20 20" class="w-3.5 h-3.5" fill="none" aria-hidden="true"><path d="M4 10.5l4 4 8-9" stroke="#538125" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>' : i) + '</span>';
      lijst.appendChild(li);
    }
    body.innerHTML = '';
    if (stap > 7) { renderResultaat(body); return; }
    var s = STAPPEN[stap - 1];
    if (sec) sec.textContent = s.sec;
    var h = document.createElement('div');
    h.className = 'tw-text-center mb-6';
    h.innerHTML = '<h3 class="text-2xl font-bold text-black">' + s.titel.replace('{merk}', antw.merk || '') + '</h3><p class="text-sm text-black/60 mt-1">' + s.sub + '</p>';
    body.appendChild(h);
    var grid = document.createElement('div');
    body.appendChild(grid);
    function kies(k, v) { antw[k] = v; stap++; renderStap(); }

    if (stap === 1) {
      grid.innerHTML = NBT("<p class=\"text-[11px] font-bold tracking-widest text-black/50 mb-2\">人気</p>");
      var top = document.createElement('div'); top.className = 'tw-grid grid-cols-2 gap-3 mb-5';
      MERKEN_TOP.forEach(function (m) { var b = knop((MERK_LOGO[m] ? '<span style="display:flex;justify-content:center;align-items:center;height:48px;margin:0 auto 8px;color:#000">' + MERK_LOGO[m] + '</span>' : '') + '<span class="font-bold text-lg">' + m + '</span>', 'tw-border border-[#E5E7EB] rounded-2xl py-5 hover:border-[#538125] hover:bg-[#F8FAF8] transition-all'); b.addEventListener('click', function () { kies('merk', m); }); top.appendChild(b); });
      grid.appendChild(top);
      grid.insertAdjacentHTML('beforeend', NBT("<p class=\"text-[11px] font-bold tracking-widest text-black/50 mb-2\">その他のブランド</p>"));
      var rest = document.createElement('div'); rest.className = 'tw-grid grid-cols-2 sm:grid-cols-4 gap-3';
      MERKEN.forEach(function (m) { var b = knop('<span class="font-semibold text-sm">' + m + '</span>', 'tw-border border-[#E5E7EB] rounded-2xl py-4 hover:border-[#538125] hover:bg-[#F8FAF8] transition-all tw-text-center'); b.addEventListener('click', function () { kies('merk', m); }); rest.appendChild(b); });
      grid.appendChild(rest);
    } else if (stap === 2) {
      var tabs = document.createElement('div'); tabs.className = 'tw-flex rounded-[10px] bg-[#F3F3F3] p-1 mb-5';
      ['men', 'women'].forEach(function (g) {
        var b = knop(g === 'men' ? "メンズ" : NBT("レディース"), 'flex-1 py-2 rounded-[8px] text-sm font-semibold ' + (antw.gender === g ? 'bg-white text-[#538125] shadow' : 'text-[#4A5565]'));
        b.addEventListener('click', function () { antw.gender = g; renderStap(); });
        tabs.appendChild(b);
      });
      grid.appendChild(tabs);
      var van = antw.gender === 'men' ? 24 : 21.5, tot = antw.gender === 'men' ? 31 : 27;
      var g5 = document.createElement('div'); g5.className = 'tw-grid grid-cols-4 sm:grid-cols-5 gap-3';
      for (var c = van; c <= tot + 0.01; c += 0.5) {
        (function (val) {
          var b = knop(val.toFixed(1) + '<span class="text-xs font-normal">cm</span>', 'tw-border border-[#E5E7EB] rounded-2xl py-4 font-bold text-lg hover:border-[#538125] hover:bg-[#F8FAF8] transition-all');
          b.addEventListener('click', function () { kies('cm', val); });
          g5.appendChild(b);
        })(c);
      }
      grid.appendChild(g5);
    } else if (stap === 3) {
      grid.className = 'tw-flex flex-col gap-3';
      [['tight', NBT("きつい"), NBT("つま先が窮屈に感じる")], ['perfect', NBT("ちょうどいい"), NBT("一日中快適")], ['loose', NBT("ゆるい"), NBT("靴の中で足が動く")]].forEach(function (o) { var b = optieKaart(o[1], o[2]); b.addEventListener('click', function () { kies('fit', o[0]); }); grid.appendChild(b); });
    } else if (stap === 4) {
      grid.className = 'tw-grid sm:grid-cols-2 gap-3';
      grid.insertAdjacentHTML('afterbegin', NBT("<p class=\"sm:col-span-2 tw-text-center text-xs bg-[#F8FAF8] rounded-full py-1.5 px-4 w-fit mx-auto\" style=\"color:#538125\">ベアフットシューズは足指が自然に広がるゆとり設計です</p>"));
      [['narrow', NBT("細め"), NBT("細い足で、幅の狭い靴が合う")], ['normal', NBT("ふつう"), NBT("標準的な幅で、たいていの靴が合う")], ['wide', NBT("幅広"), NBT("つま先にゆとりが必要")], ['very_wide', NBT("かなり幅広"), NBT("幅のためにサイズを上げることが多い")]].forEach(function (o) { var b = optieKaart(o[1], o[2]); b.addEventListener('click', function () { kies('breedte', o[0]); }); grid.appendChild(b); });
    } else if (stap === 5) {
      grid.className = 'tw-flex flex-col gap-3';
      [['snug', NBT("フィット感重視"), NBT("スポーツシューズのように、ゆとりは最小限")], ['natural', NBT("自然なゆとり"), NBT("足指が心地よく動かせる")], ['extra', NBT("しっかりゆとり（ベアフット感）"), NBT("足指が最大限に自由に動く")]].forEach(function (o) { var b = optieKaart(o[1], o[2]); b.addEventListener('click', function () { kies('tenen', o[0]); }); grid.appendChild(b); });
    } else if (stap === 6) {
      grid.className = 'tw-grid sm:grid-cols-2 gap-3';
      antw.klachten = antw.klachten || [];
      [['bunions', NBT("外反母趾が気になる"), NBT("親指のつけ根が出っ張っている")], ['hammertoe', NBT("足指の曲がりが気になる"), NBT("足指が曲がったり重なったりする")], ['flat', NBT("扁平足"), NBT("土踏まずが低い・ない")], ['high_arch', NBT("ハイアーチ"), NBT("土踏まずが高い")], ['heel', NBT("かかとの負担が気になる"), NBT("朝や長時間の歩行後にかかとがつらい")], ['none', NBT("特になし"), NBT("当てはまるものはない")]].forEach(function (o) {
        var aan = antw.klachten.indexOf(o[0]) >= 0;
        var b = optieKaart(o[1], o[2], '', aan ? 'border-[#538125] bg-[#F8FAF8] ring-1 ring-[#538125]' : '');
        b.addEventListener('click', function () {
          if (o[0] === 'none') antw.klachten = ['none'];
          else { antw.klachten = antw.klachten.filter(function (k) { return k !== 'none'; }); var i = antw.klachten.indexOf(o[0]); if (i >= 0) antw.klachten.splice(i, 1); else antw.klachten.push(o[0]); }
          renderStap();
        });
        grid.appendChild(b);
      });
      var door = volgendeKnop(NBT("次へ →")); door.classList.add('sm:col-span-2');
      door.disabled = antw.klachten.length === 0;
      door.addEventListener('click', function () { stap++; renderStap(); });
      grid.appendChild(door);
    } else if (stap === 7) {
      grid.className = 'tw-grid sm:grid-cols-2 gap-3';
      [['walking', NBT("毎日の散歩・お出かけ"), NBT("街なかでの普段履き")], ['work', NBT("立ち仕事・通勤"), NBT("一日中立ったり歩いたり")], ['casual', NBT("レジャー"), NBT("公園やアウトドアで")], ['hiking', NBT("ハイキング"), NBT("山道や自然の中で")], ['exercise', NBT("運動・ジム"), NBT("トレーニングやフィットネス")]].forEach(function (o) { var b = optieKaart(o[1], o[2]); b.addEventListener('click', function () { kies('activiteit', o[0]); }); grid.appendChild(b); });
    }
  }

  // Hike-regels (api/size-recommendation), in cm-stappen van 0.5. Zie NB_QUIZ_REGELS voor de precieze waarden.
  function bereken() {
    var basis = antw.cm + (MERK_OFFSET[antw.merk] || 0);
    var redenen = [];
    var R = QUIZ.stappen || { tight: 0.5, loose: -0.5, narrow: -0.5, wide: 0, very_wide: 0.5, extra: 0.5, snug: 0, bunions: 0.5, hammertoe: 0.5, flat: 0, high_arch: 0, heel: 0, hiking: 0.5, work: 0.5, exercise: 0.5, walking: 0, casual: 0 };
    var off = MERK_OFFSET[antw.merk] || 0;
    if (off > 0) redenen.push(antw.merk + NBT("は小さめ・細めに作られているため、NOBIASHIの相当サイズ（+") + off.toFixed(1) + NBT("cm）に調整"));
    if (off < 0) redenen.push(antw.merk + NBT("は大きめに作られているため、NOBIASHIの相当サイズ（") + off.toFixed(1) + NBT("cm）に調整"));
    var d = 0;
    function voeg(k, tekst) { var v = R[k] || 0; d += v; if (tekst) redenen.push(tekst); }
    if (antw.fit === 'tight') voeg('tight', NBT("今の靴がきつい → 0.5cm上げます"));
    if (antw.fit === 'loose') voeg('loose', NBT("今の靴がゆるい → 0.5cm下げます"));
    if (antw.breedte === 'narrow') voeg('narrow', NBT("幅広のつま先設計は細めの足にゆとりがある → 0.5cm下げます"));
    if (antw.breedte === 'wide') voeg('wide', NBT("幅広の足 → ゆとりのある長さで快適に"));
    if (antw.breedte === 'very_wide') voeg('very_wide', NBT("かなり幅広の足 → 0.5cm上げてゆとりを確保"));
    if (antw.tenen === 'extra') voeg('extra', NBT("しっかりゆとり派 → 0.5cm上げてベアフットの自由さを"));
    if (antw.tenen === 'snug') voeg('snug', NBT("フィット感重視 → 計算サイズのまま"));
    (antw.klachten || []).forEach(function (k) {
      if (k === 'bunions') voeg('bunions', NBT("外反母趾 → 前足部にゆとりが必要なので 0.5cm上げます"));
      if (k === 'hammertoe') voeg('hammertoe', NBT("足指の曲がり → 前足部にゆとりが必要なので 0.5cm上げます"));
      if (k === 'flat') voeg('flat', NBT("扁平足 → ジャストサイズでインソールが足を支えます"));
      if (k === 'heel') voeg('heel', NBT("かかとの負担 → ジャストサイズがいちばん安定します"));
      if (k === 'high_arch') voeg('high_arch', NBT("ハイアーチ → 深めのヒールカップにはジャストサイズが最適"));
    });
    if (antw.activiteit === 'hiking') voeg('hiking', NBT("ハイキングでは足がむくむ → 下りでつま先が当たらないようゆとりを"));
    if (antw.activiteit === 'work') voeg('work', NBT("長時間の立ち仕事は足がむくむ → 夕方も快適な0.5cm上げ"));
    if (antw.activiteit === 'exercise') voeg('exercise', NBT("運動時は足がむくむ → パフォーマンスのためにゆとりを"));
    var max = QUIZ.max !== undefined ? QUIZ.max : 1.0, min = QUIZ.min !== undefined ? QUIZ.min : -0.5;
    d = Math.max(min, Math.min(max, d));
    var doel = basis + d;
    // dichtstbijzijnde beschikbare maat (bij gelijke afstand: groter, barefoot)
    var best = null, bestAfst = 99;
    P.maten.forEach(function (m) {
      var c = cm(m); if (isNaN(c)) return;
      var a = Math.abs(c - doel) - (c > doel ? 0.01 : 0);
      if (a < bestAfst) { bestAfst = a; best = m; }
    });
    var stappen = Math.abs(d) / 0.5;
    var conf = Math.max(80, Math.round((QUIZ.confBasis || 95) - stappen * (QUIZ.confStap || 3) - (bestAfst > 0.3 ? 3 : 0)));
    return { maat: best, doel: doel, conf: conf, redenen: redenen };
  }
  function renderResultaat(body) {
    var r = bereken();
    var row = rij(r.maat) || [];
    var kopEl = q('[data-nb-quiz-kop]');
    body.innerHTML = '<div class="tw-text-center">' +
      '<span class="w-14 h-14 rounded-full bg-[#538125] tw-flex items-center tw-justify-center mx-auto mb-4"><svg viewBox="0 0 20 20" class="w-7 h-7" fill="none" aria-hidden="true"><path d="M4 10.5l4 4 8-9" stroke="#fff" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg></span>' +
      NBT("<h3 class=\"text-2xl font-bold text-black\">ぴったりのサイズが見つかりました！</h3><p class=\"text-sm text-black/60 mt-1\">あなたの足のプロフィールにもとづくおすすめです</p>") +
      '<div class="mt-6 rounded-2xl tw-border border-[#CAD3BE] nb-trust-bg p-6 tw-text-center">' +
      NBT("<p class=\"text-[11px] font-bold tracking-widest text-black/60\">おすすめサイズ</p>") +
      '<p class="text-5xl font-extrabold text-[#538125] my-2">' + r.maat + '</p>' +
      
      NBT("<span class=\"inline-flex items-center gap-1 bg-white rounded-full px-3 py-1 text-sm font-semibold mt-3\">マッチ度 ") + r.conf + '%</span>' +
      (r.redenen.length ? '<ul class="tw-text-left text-sm text-black/80 mt-5 space-y-2 bg-white rounded-xl p-4">' + r.redenen.map(function (t) { return '<li class="tw-flex gap-2"><svg viewBox="0 0 20 20" class="w-4 h-4 shrink-0 mt-0.5" fill="none" aria-hidden="true"><path d="M4 10.5l4 4 8-9" stroke="#538125" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg><span>' + t + '</span></li>'; }).join('') + '</ul>' : '') +
      '</div>' +
      NBT("<button type=\"button\" class=\"w-full bg-[#538125] text-white rounded-[10px] py-4 font-bold text-lg mt-6 hover:bg-[#4d7a22]\" data-nb-quiz-kies>サイズ ") + r.maat + NBT(" を選ぶ →</button>") +
      NBT("<button type=\"button\" class=\"block mx-auto mt-3 text-sm font-semibold underline text-black/70\" data-nb-quiz-opnieuw>もう一度診断する</button>") +
      '</div>';
    body.querySelector('[data-nb-quiz-kies]').addEventListener('click', function () {
      if (r.maat) { maat = r.maat; naKeuze(false); }
      if (antw.gender !== gender) { var gb = q('[data-nb-gender-btn="' + antw.gender + '"]'); if (gb) gb.click(); }
      sluit(); toon(lade, false);
    });
    body.querySelector('[data-nb-quiz-opnieuw]').addEventListener('click', function () { stap = 1; antw = { gender: gender }; renderStap(); });
  }

  /* ---------------------------------------------------------------- start */
  naKeuze(false);
})();

// bijna uitverkocht: paneel open/dicht
document.querySelectorAll('[data-nb-schaars-knop]').forEach(function (knop) {
  var paneel = knop.parentNode.querySelector('.nbp-schaars__paneel');
  if (!paneel) return;
  knop.addEventListener('click', function () {
    var open = knop.getAttribute('aria-expanded') === 'true';
    knop.setAttribute('aria-expanded', String(!open));
    paneel.hidden = open;
  });
});
